var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-and-right-layout"},[_c('div',{staticClass:"left"},[_vm._t("left")],2),_c('div',{staticClass:"right",style:(`margin-left: ${ _vm.margin }px`)},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }